module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1114.2823a557.png";